import { createAsyncThunk } from '@reduxjs/toolkit'
import CuratedMediaList from './curated-media-list-model'
import {
  delete_curatedMediaList,
  load_curatedMediaLists,
  store_curatedMediaList,
} from './curatedMediaList-service'

export const LoadCuratedMediaListsAsync = createAsyncThunk<any, any>(
  'composer/load/curatedMediaList',
  async (params: { uid: string }) => {
    return await load_curatedMediaLists(params)
  },
)

export const CreateCuratedMediaListAsync = createAsyncThunk<any, any>(
  'composer/create/curatedMediaList',
  async (params: CuratedMediaList) => {
    return await store_curatedMediaList(params)
  },
)

export const DeleteCuratedMediaListAsync = createAsyncThunk<any, any>(
  'composer/delete/curatedMediaList',
  async (params) => {
    return await delete_curatedMediaList(params)
  },
)
